import { MockRoute } from './mockBackend';
import { companyRoutes } from './sections/company';
import { identityRoutes } from './sections/identity';
import { profileRoutes } from './sections/profile';
import { teamRoutes } from './sections/team';
import { trainingRoutes } from './sections/training';

// Single aggregation point for all mock routes. Adding a section = author `sections/<name>.ts`
// exporting a MockRoute[] and spread it here. The dispatch core (mockBackend.ts) never changes.
export const routes: MockRoute[] = [
  ...identityRoutes,
  ...teamRoutes,
  ...profileRoutes,
  ...companyRoutes,
  ...trainingRoutes,
];
